import FallbackSpin from '@/components/Shared/FallbackSpin';
import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import Vote from '../views/vote';
import VoteResults from '../views/voteResults';
import VoteResultsByShareholder from '../views/voteResultsByShareholder';

export const VoteRoutes = () => {
  return (
    <Suspense fallback={<FallbackSpin />}>
      <Routes>
        <Route path="results/:meetingID" element={<VoteResults />} />
        <Route path="resultsByShareholder/:meetingID" element={<VoteResultsByShareholder />} />
        <Route path="questions/:meetingID" element={<Vote />} />
      </Routes>
    </Suspense>
  );
};
